import { TranscriptionStatus } from "@/store/audio/recording/media-types";

interface TranscriptionMonitorOptions {
  maxReconnectAttempts: number;
}

export class TranscriptionMonitor {
  private currentStatus: TranscriptionStatus = TranscriptionStatus.Live;
  private reconnectAttempts = 0;
  private readonly maxReconnectAttempts: number;

  constructor({ maxReconnectAttempts }: TranscriptionMonitorOptions) {
    this.maxReconnectAttempts = maxReconnectAttempts;
  }

  get status(): TranscriptionStatus {
    return this.currentStatus;
  }

  markConnected(): TranscriptionStatus | null {
    this.reconnectAttempts = 0;
    return this.updateStatus(TranscriptionStatus.Live);
  }

  markDisconnected(): TranscriptionStatus | null {
    return this.updateStatus(TranscriptionStatus.Disconnected);
  }

  recordReconnectFailure(): TranscriptionStatus | null {
    this.reconnectAttempts += 1;
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      return this.updateStatus(TranscriptionStatus.Compromised);
    }

    return this.updateStatus(TranscriptionStatus.Disconnected);
  }

  private updateStatus(status: TranscriptionStatus): TranscriptionStatus | null {
    if (
      this.currentStatus === TranscriptionStatus.Compromised &&
      status !== TranscriptionStatus.Compromised
    ) {
      return null;
    }

    if (status === this.currentStatus) {
      return null;
    }

    this.currentStatus = status;
    return this.currentStatus;
  }
}
